import React from 'react';
import PropTypes from 'prop-types';

import SlugEditor from './SlugEditor';
import DetailsEditor from './DetailsEditor';

import { Box } from '@mui/material';
import ThemeEditor from './ThemeEditor.js';

const OrganizationEditor = ({organization, onOrganizationChange, onPreviewModalOpen, socials, onSocialsEditorSave, onUnsavedChangesChange}) => {

  const handleOrganizationChange = (newOrganization) => {
    onOrganizationChange(newOrganization);
    onUnsavedChangesChange(true);
  };

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>

      <SlugEditor 
        organization={organization} 
        onOrganizationChange={handleOrganizationChange} 
        onPreviewModalOpen={onPreviewModalOpen} 
      />

      <DetailsEditor 
        organization={organization}
        onOrganizationChange={handleOrganizationChange}
        socials={socials}
        onSave={onSocialsEditorSave}
      />

      <ThemeEditor 
        organization={organization}
        onOrganizationChange={handleOrganizationChange}
      />
    </Box>
  );
};

OrganizationEditor.propTypes = {
  organization: PropTypes.object,
  onOrganizationChange: PropTypes.func,
  onPreviewModalOpen: PropTypes.func,
  socials: PropTypes.array,
  onSocialsEditorSave: PropTypes.func,
  onUnsavedChangesChange: PropTypes.func,
};

export default OrganizationEditor 